import React from 'react'
import { SvgIconProps } from './Home'

const SvgProgramBuilderIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    width={width ?? '24'}
    height={height ?? '24'}
    viewBox={`0 0 ${height ?? '24'} ${width ?? '24'}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 21H8.78571V13.52H3V5.36H4.28571V4H8.14286V5.36H10.0714V4H13.9286V5.36H15.2143V12.84H15.8571V11.48H19.7143V12.84H21V21ZM9.42857 20.32H20.3571V13.52H9.42857V20.32ZM16.5 12.84H19.0714V12.16H16.5V12.84ZM3.64286 12.84H14.5714V6.04H3.64286V12.84ZM10.7143 5.36H13.2857V4.68H10.7143V5.36ZM4.92857 5.36H7.5V4.68H4.92857V5.36Z"
      fill={fill ?? '#353535'}
      stroke={fill ?? '#353535'}
    />
  </svg>
)

export default SvgProgramBuilderIcon
